module.exports = __webpack_public_path__ + "c3ccd232.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/BasicHeader/new_saocal_20.png
// module id = 1112
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20